function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.138 14.8L12 22c-1.603-.548-2.927-.699-3.791-.432-2.32.716-.811 4.193 3.37 7.767 4.18 3.574 9.45 5.89 11.77 5.175.865-.267 1.228-.938 1.04-1.922l26.222-8.09z",
  strokeLinecap: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.046 23.353c-.09 7.484.352 7.754 4.533 11.328 4.18 3.574 9.45 5.89 11.77 5.175.865-.267 1.228-.938 1.04-1.922l26.222-8.09v-5.243",
  strokeLinecap: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.957 26.382L1.61 28.164 19.43 43.309l34.745-11.582-3.564-2.673"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.046 32.797c-.09 7.484.352 5.615 4.533 9.19 4.18 3.573 9.45 5.89 11.77 5.174.865-.266 1.228-.937 1.04-1.921l26.222-8.09v-4.175"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(34.594)",
  cx: 30.193,
  cy: 10.676,
  rx: 0.891,
  ry: 0.445
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(20.902)",
  cx: 30.63,
  cy: 12.161,
  rx: 0.445,
  ry: 0.109
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(22.982)",
  cx: 36.282,
  cy: 7.266,
  rx: 0.445,
  ry: 0.181
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(22.756)",
  cx: 42.525,
  cy: 7.39,
  rx: 0.891,
  ry: 0.445
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(17.777)",
  cx: 29.354,
  cy: 23.54,
  rx: 0.445,
  ry: 0.157
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.784,
  cy: 27.02,
  rx: 0.445,
  ry: 0.253
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 37.693,
  cy: 18.159,
  rx: 0.445,
  ry: 0.205
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(20.902)",
  cx: 20.133,
  cy: 18.311,
  rx: 0.445,
  ry: 0.109
})));

var SvgSandwich = function SvgSandwich(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSandwich, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sandwich.a59fe492.svg";
export { ForwardRef as ReactComponent };